<template>
<div id="new-assigments">
        <div class="text-center" v-if="isLoadingReports">
            <loader width="5rem"></loader>
        </div>
        <div class="text-center vert-center" v-else-if="openAssignements.length == 0">
            <h5  class="mx-auto text-muted">Er zijn momenteel geen nieuwe opdrachten.</h5>
        </div>
        <div class="list-group">
        <transition-group name="fade">
            <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="a in openAssignements" :key="a.id">
                <div class="d-flex w-100 justify-content-between">
                    <h4 class="mb-1">{{a.city}} | {{a.title}}</h4>
                    <small class="invisible-sm">Publicatiedatum: {{new Date(a.publicationDate).toLocaleDateString()}}</small>
                </div>
                <div class="visible-sm invisible-md">
                    <p class="mb-1"><span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}}</span></p>
                    <p class="mb-1"><strong>Uitbetaling: € {{a.rate.toFixed(2)}} <sup>*</sup></strong></p>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <div class="invisible-sm">
                        <p class="mb-1">{{a.description}}</p>
                        <p class="mb-1">Datums: <span class="badge badge-secondary mr-1" v-for="d in a.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}} ({{d.hours}} uur)</span></p>
                        <p class="mb-1" v-if="a.rate > 0"><strong>Verwachte uitbetaling: € {{a.rate.toFixed(2)}} <sup>*</sup></strong></p>
                    </div>
                    <loader width="3rem" v-if="isLoading"></loader>
                    <div class="btn-group" v-else-if="a.status === 1">
                        <button class="btn btn-outline-success mr-3" @click="accept(a)">Accepteren</button>
                        <button class="btn btn-outline-danger" @click="decline(a)">Weigeren</button>
                    </div>                            
                    <router-link tag="button" class="btn btn-outline-azure" :to="{ name: 'ProfessionalAssignment', params: { 'id': a.id } }" v-else-if="a.status === 2" >Opdracht Bekijken</router-link>
                </div>
            </div>
        </transition-group>
    </div>
</div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    name: 'new-assignments',
    components: {
        Loader
    },
    data() {
        return {
            openAssignements: [],
            isLoading: false,
            isLoadingReports: false
        }
    },
    mounted() {
        this.getOpenAssignments();
    },
    methods: {
        getOpenAssignments() {
            this.isLoadingReports = true;
            this.$http.get("api/Assignments/Professional/Open?take=999").then((res) => {
                this.isLoadingReports = false;
                this.openAssignements = res.data;
            }).catch(() => {
                this.isLoadingReports = false;
            });
        },
        accept(assignment, ev) {
            this.isLoading = true;
            this.$http.post('api/Assignments/Accept/' + assignment.id).then((res) => 
            {
                assignment.status = 2;
                this.$emit('update', assignment);
                this.openAssignements.splice(this.openAssignements.indexOf(assignment), 1);
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        decline(assignment) {
            this.isLoading = true;
            this.$http.post('api/Assignments/Decline/' + assignment.id).then((res) => 
            {
                this.openAssignements.splice(this.openAssignements.indexOf(assignment), 1);
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        }
    },
}
</script>